import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

Vue.component('app-CMenuLastfall', require('./components/contextmenus/lastfallmenu.vue').default)
Vue.component('app-CMenuMaterial', require('./components/contextmenus/materialmenu.vue').default)
Vue.component('app-CMenuQuerschnitt', require('./components/contextmenus/querschnittmenu.vue').default)
Vue.component('app-CMenuAuflager', require('./components/contextmenus/auflagermenu.vue').default)
Vue.component('app-CMenuGelenk', require('./components/contextmenus/gelenkmenu.vue').default)
Vue.component('app-CMenuKnoten', require('./components/contextmenus/knotenmenu.vue').default)
Vue.component('app-CMenuStab', require('./components/contextmenus/stabmenu.vue').default)
Vue.component('app-CMenuKnotenlast', require('./components/contextmenus/knotenlastmenu.vue').default)
Vue.component('app-CMenuStablast', require('./components/contextmenus/stablastmenu.vue').default)
Vue.component('app-CMenuPrint', require('./components/contextmenus/printmenu.vue').default)
Vue.component('app-CMenuMoveSelection', require('./components/contextmenus/movemenu.vue').default)
Vue.component('app-CMenuDivideStab', require('./components/contextmenus/dividemenu.vue').default)

Vue.component('app-ColorMap', require('./components/contextmenus/colormap.vue').default)

Vue.component('app-table-Auflager', require('./components/tables/AuflagerTable.vue').default)
Vue.component('app-table-Knoten', require('./components/tables/KnotenTable.vue').default)
Vue.component('app-table-Material', require('./components/tables/MaterialTable.vue').default)
Vue.component('app-table-Querschnitt', require('./components/tables/QuerschnittTable.vue').default)
Vue.component('app-table-Gelenk', require('./components/tables/GelenkTable.vue').default)
Vue.component('app-table-Stab', require('./components/tables/StabTable.vue').default)
Vue.component('app-table-Lastfall', require('./components/tables/LastfallTable.vue').default)

Vue.component('app-new-DLT', require('./components/menus/newDLT_dialog.vue').default)
Vue.component('app-new-BalkenkopfRep', require('./components/menus/newBalkenkopfRep_dialog.vue').default)

new Vue({
  //router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
